// extracted by mini-css-extract-plugin
export default {"gridContainer":"InquiryForm_gridContainer__NcoIj","message":"InquiryForm_message__ek7aK","errorText":"InquiryForm_errorText__vD2ck"};